import PropTypes from 'prop-types';
import React, { useState } from 'react';

const CloseIcon = ({ theme }) => {
  const [color, setColor] = useState('#66737E');

  return (
    <svg
      data-name="Layer 1"
      fill={color}
      id="Layer_1"
      onMouseOut={() => {
        setColor('#66737E');
      }}
      onMouseOver={() => {
        if (theme === 'ak529') {
          setColor('#520F9A');
        } else if (theme === 'md529') {
          setColor('#ED8B00');
        } else {
          setColor('#006894');
        }
      }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>close</title>
      <path d="M23.85.15a.48.48,0,0,0-.7,0L12,11.29.85.15a.48.48,0,0,0-.7,0,.48.48,0,0,0,0,.7L11.29,12,.15,23.15a.48.48,0,0,0,0,.7A.47.47,0,0,0,.5,24a.47.47,0,0,0,.35-.15L12,12.71,23.15,23.85a.48.48,0,0,0,.7,0,.48.48,0,0,0,0-.7L12.71,12,23.85.85A.48.48,0,0,0,23.85.15Z" />
    </svg>
  );
};

CloseIcon.propTypes = {
  theme: PropTypes.string
};

export default CloseIcon;
